import { render } from "./splashScreen.vue?vue&type=template&id=22cf1f89&scoped=true"
import script from "./splashScreen.vue?vue&type=script&lang=js"
export * from "./splashScreen.vue?vue&type=script&lang=js"

import "./splashScreen.vue?vue&type=style&index=0&id=22cf1f89&scoped=true&lang=css"

import exportComponent from "/Users/mohammedali/Documents/GitHub/travelPlanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cf1f89"]])

export default __exports__